import React from 'react';
import './UIInputPairsWithLabels.scss';

// Props for a single input pair (label + input)
export interface UIInputPair {
  label: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

// Props for the entire component
export interface UIInputPairsWithLabelsProps {
  pairs: UIInputPair[];
  labelWidth?: number; // Width of each label in percentage
  className?: string;
}

const UIInputPairsWithLabels: React.FC<UIInputPairsWithLabelsProps> = ({
                                                                         pairs = [],
                                                                         labelWidth = 25, // Default label width
                                                                         className = '',
                                                                       }) => {
  const renderLabel = (label: string) => {
    const parts = label.split('*');
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <span className="UIInputPairsWithLabels__asterisk">*</span>}
      </React.Fragment>
    ));
  };

  const labelStyle = {
    flex: `0 0 ${labelWidth}%`,
  };

  const inputStyle = {
    flex: '1',
  };

  return (
    <div className={`UIInputPairsWithLabels ${className}`}>
      {pairs.map((pair, index) => (
        <React.Fragment key={index}>
          <label className="UIInputPairsWithLabels__label" style={labelStyle}>
            {renderLabel(pair.label)}
          </label>
          <input
            className="UIInputPairsWithLabels__input"
            style={inputStyle}
            value={pair.value}
            onChange={pair.onChange}
            placeholder={pair.placeholder}
            {...pair.inputProps}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default UIInputPairsWithLabels;